import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconCall = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#03c75a',
    width = '100%',
    height = '100%',
    viewBox = '0 0 17 17',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(0.000000, -1.000000)",
    stroke: fill
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.000000)",
    id: "call_icn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8866175,15.6 C6.90395667,14.407898 2.19240592,9.69378061 1,3.70688978 L3.70421312,1 L4.46489245,1.76121717 L7.83885487,5.13068322 L7.03691317,5.93051562 L5.70620192,7.26216775 C6.57958863,8.78919004 7.85146281,10.0589049 9.38581148,10.9222039 C9.39230648,10.9260272 9.39918355,10.9306151 9.40606061,10.9340561 L11.5253415,8.81557074 L14.8458157,12.13304 L15.6,12.8862283 L12.8866175,15.6 Z",
    id: "ic_call"
  }))))));
});

export { IconCall as default };
